import React, { useContext } from 'react'
import {
  UneeqProvider,
  UneeqAvatar,
  UneeqLocalVideo,
  UneeqContext,
  useUneeqState,
  Uneeq,
  UneeqCoreConfig
} from 'uneeq-react-core'
import { Box } from 'rebass'
import Menu from './Components/Menu'
import BottomBar from './Components/BottomBar'
import OnScreenInfo from './Components/OnScreenInfo'
import Errors from './Components/Errors'
import Settings from './Components/Settings'
import Timeout from './Components/Timeout'
import Feedback from './Components/endSession/Feedback'
import EscalationForm from './Components/endSession/EscalationForm'
import EndSessionButton from './Components/endSession/EndSessionButton'
import PrivacySummary from './Components/PrivacySummary'

import EndSessionConfirm from './Components/endSession/EndSessionConfirm'
import styles from './styles'
import BackButton from './Components/BackButton'
import { Gateway } from './index'

const DigitalHumanContent = ({
  restart,
  CustomFeedback,
  permissions,
  audio,
  loadingTips
}: any) => {
  const FinalFeedback = CustomFeedback || Feedback
  const { feedbackOpen } = useUneeqState()
  const { config, dispatch } = useContext(UneeqContext)

  return (
    <Box sx={styles.container}>
      <UneeqAvatar />

      {/* Must be present but we want it hidden */}
      <UneeqLocalVideo style={styles.localVideo} />

      <Gateway restart={restart} loadingTips={loadingTips} video={permissions}>
        <OnScreenInfo />
        {/* <Transcript /> */}
        <BottomBar />

        {/* Modals */}
        <Menu />
        <Settings audio={audio} />
        <Timeout />
        <PrivacySummary />
        <EndSessionConfirm restart={restart} />
        <FinalFeedback
          restart={restart}
          close={() => dispatch({ type: 'openFeedback', payload: false })}
          isOpen={feedbackOpen}
        />
        <EscalationForm restart={restart} />

        <Errors />
        {config.showBackButton && <BackButton />}
        <EndSessionButton restart={restart} />
      </Gateway>
    </Box>
  )
}

interface DigitalHumanProps {
  assets: any
  onTimedOut: () => void
  onSessionEnded: () => void
  config: Partial<UneeqCoreConfig>
  postInit?: (uneeq: Uneeq) => void
  token?: string
  restart: () => void
  loadingTips: Array<any>
  CustomFeedback?: any
}

const DigitalHuman: React.FC<DigitalHumanProps> = ({
  assets,
  onTimedOut,
  onSessionEnded,
  restart,
  postInit,
  config,
  token,
  loadingTips,
  CustomFeedback
}) => {
  const {
    video: { permissions },
    audio
  } = assets

  return (
    <UneeqProvider
      config={config}
      token={token}
      postInit={postInit}
      onTimedOut={onTimedOut}
      onSessionEnded={onSessionEnded}
      reducers={[]}
    >
      <DigitalHumanContent
        CustomFeedback={CustomFeedback}
        restart={restart}
        audio={audio}
        permissions={permissions}
        loadingTips={loadingTips}
      />
    </UneeqProvider>
  )
}

export default DigitalHuman
